var _title, _desc, _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgErrorIcon = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "77px",
    height: "67px",
    viewBox: "0 0 77 67",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "Group 2")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "path-1",
    points: "34.8913043 -1.24344979e-13 2.13162821e-14 59.673913 68.8043478 59.673913"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Errors/empty-states",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "No-flights-found-due-to-too-many-filters",
    transform: "translate(-802.000000, -384.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(806.000000, 388.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-8"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Path-2",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#E5E5E5",
    fillRule: "evenodd",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#E5E5E5",
    strokeWidth: 3.26086957,
    d: "M34.9113881,-3.26452744 L71.6062681,61.3043478 L-2.84199794,61.3043478 L34.9113881,-3.26452744 Z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#FFFFFF",
    strokeWidth: 3.26086957,
    d: "M34.8712205,3.26452744 L2.84199794,58.0434783 L66.0024276,58.0434783 L34.8712205,3.26452744 Z",
    strokeLinejoin: "square"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M35.8185292,45.008322 L36.7547554,32.8564878 L36.7547554,23.6279721 L32.8761039,23.6279721 L32.8761039,32.8564878 L33.8696501,45.008322 L35.8185292,45.008322 Z M36.6783288,51.6956522 L36.6783288,47.7214674 L32.8761039,47.7214674 L32.8761039,51.6956522 L36.6783288,51.6956522 Z",
    id: "!",
    fill: "#CCCCCC",
    fillRule: "nonzero"
  })))))));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgErrorIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/error-icon.ae563a2f.svg";
export { ForwardRef as ReactComponent };